<template>
  <div id="index">
     
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'index',
  data:function(){
    return{
      lang: 'zh-CN',
      changeLang: 'English',
      enSrc:'/static/images/english.png',
      chineseSrc:'/static/images/chinese.png',
      photoSrc:'',
    }
  },
  mounted(){
    this.photoSrc = this.enSrc
  },
  methods:{
    changeLangEvent() {
          if (this.photoSrc == this.chineseSrc) {
               this.photoSrc = this.enSrc;
           } else {
               this.photoSrc = this.chineseSrc;
           }
           if (this.lang === 'zh-CN') {
               this.lang = 'en-US';
               this.$i18n.locale = this.lang;
           } else {
               this.lang = 'zh-CN';
               this.$i18n.locale = this.lang;
           }
       },
  }
}
</script>

<style lang="scss">
#index {
  .lang{
    position: absolute;
    right: 5px;
    top: 5px;
    color: 	#FF4500;
    cursor: pointer;
    z-index: 999;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue


// WEBPACK FOOTER //
// src/views/index/index.vue